import axios from "axios";
import request from "../infra/request";
import { StatusCodes } from "http-status-codes";
import firebase from "./firebase";
import { STATUS } from "../constants";

export const getSpecialitiesWithSpecialistProfiles = async () => {
  try {
    const userIdToken = await firebase.currentUser().getIdToken();
    const { data, status } = await axios.get(`${process.env.REACT_APP_API_HOST}/admin/specialists/specialities`, {
      headers: { Authorization: `Bearer ${userIdToken}` },
    });

    if (status === StatusCodes.OK) {
      return { data, status: STATUS.SUCCEED };
    }
    return { status: STATUS.FAILED };
  } catch (error) {
    return { status: STATUS.FAILED, error };
  }
};

export const getSpecialities = async () => {
  let endpoint = `${process.env.REACT_APP_API_HOST}/admin/specialists/speciality`;
  return request.get(endpoint).then((res) => res.data);
};

export const createSpeciality = async (speciality) => {
  let endpoint = `${process.env.REACT_APP_API_HOST}/admin/specialists/speciality`;
  return request.post(endpoint, { name: speciality.name, publishedTo: speciality.publishedTo }).then(
    (res) => res.status,
    (error) => console.log(error)
  );
};

export const updateSpeciality = async (speciality, sid) => {
  let endpoint = `${process.env.REACT_APP_API_HOST}/admin/specialists/speciality/${sid}`;
  return request.put(endpoint, { name: speciality.name, publishedTo: speciality.publishedTo }).then(
    (res) => res.status,
    (error) => console.log(error)
  );
};

export const deleteSpeciality = async (sid) => {
  let endpoint = `${process.env.REACT_APP_API_HOST}/admin/specialists/speciality/${sid}`;
  return request.delete(endpoint).then((res) => res.data);
};
